export {};

const $head = $(document.head);

$.fn.adaptiveBackground = adaptiveBackground;

NLMK.adaptiveBackgrounds = function adaptiveBackgrounds($container) {
    if ($container) {
        $container.adaptiveBackground();
        return;
    }

    $('.js-adaptive-bg').adaptiveBackground();
};

$(window)
    .ajaxSuccess(init)
    .on('adaptive-background', init);

function init() {
    NLMK.adaptiveBackgrounds();
}

function adaptiveBackground() {
    const $scope = this;

    $scope.each(function eachOfElement(indexOfElement, Element) {
        const $element = $(Element);

        if ($element.data('adaptiveBackgroundInit')) {
            return true;
        }

        $element.data('adaptiveBackgroundInit', 1);

        const uniqueClass = `adaptive-background_${+new Date()}_${indexOfElement}_${Math.floor(
            Math.random() * (1000 - 1) + 1,
        )}`;

        const sources = {
            mobile: $element.data('bg-mobile'),
            verticalTablet: $element.data('bg-vertical-tablet'),
            horizontalTablet: $element.data('bg-horizontal-tablet'),
            desktop: $element.data('bg-desktop'),
            fullhd: $element.data('bg-fullhd'),
        };

        sources.fullhd = sources.fullhd || sources.desktop;

        $.each(sources, (sourceKey, url) => {
            if (!url) {
                console.warn(`Не указан data-${sourceKey}`);
            }
        });

        $element.addClass(uniqueClass).css({
            color: $element.data('bg-text-color'),
        });

        (async () => {
            $head.append(`<style id="style-${uniqueClass}">
                    ${await createMediaQuery(
                        NLMK.mediaQueries.mobile.min,
                        NLMK.mediaQueries.mobile.max,
                        sources.mobile,
                    )}
                    ${await createMediaQuery(
                        NLMK.mediaQueries.verticalTablet.min,
                        NLMK.mediaQueries.verticalTablet.max,
                        sources.verticalTablet,
                    )}
                    ${await createMediaQuery(
                        NLMK.mediaQueries.horizontalTablet.min,
                        NLMK.mediaQueries.horizontalTablet.max,
                        sources.horizontalTablet,
                    )}
                    ${await createMediaQuery(
                        NLMK.mediaQueries.desktop.min,
                        NLMK.mediaQueries.desktop.max,
                        sources.desktop,
                    )}
                    ${await createMediaQuery(
                        NLMK.mediaQueries.fullhd.min,
                        NLMK.mediaQueries.fullhd.max,
                        sources.fullhd,
                    )}
                </style>
             `);
        })();

        /**
         *
         * @param {number} min
         * @param {number} max
         * @param {string} bgUrl
         * @returns {string}
         */
        async function createMediaQuery(min, max, bgUrl) {
            if (!bgUrl) {
                return '';
            }

            if (Modernizr.webp) {
                const bgUrlWebp = bgUrl.replace(/\.(jpe?g|png)$/i, '.webp');

                return await new Promise((resolve) => {
                    const image = new Image();

                    image.onload = async () => {
                        bgUrl = bgUrlWebp;

                        resolve(generateQuery());
                    };
                    image.onerror = async () => {
                        resolve(generateQuery());
                    };

                    image.src = bgUrlWebp;
                });
            }

            return generateQuery();

            function generateQuery() {
                return `@media (min-width: ${min}px) and (max-width: ${max}px) {
                                .${uniqueClass} {
                                    background-image: url(${bgUrl}) !important;
                                }
                            }`;
            }
        }
    });
}



// WEBPACK FOOTER //
// ./js/main/plugin/adaptive-background.js